import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DxButtonModule, DxPopupModule, DxTemplateModule, DxScrollViewModule   } from 'devextreme-angular';
import { HomeComponent } from './home/home.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DxButtonModule,
    DxPopupModule,
    DxTemplateModule,
    DxScrollViewModule 
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
